import gal from './gal.json'
import es from './es.json'

export default {
  gal,
  es
}
